import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import PrintButton from 'components/ui/PrintButton';
import useToggle from 'hooks/useToggle';
import getDoaminName from 'lib/getDomainName';
import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useUnblockTraineeMutation } from 'redux/reducers/auth';
import { IDistrict, IProvince, useListDistrictByProvinceQuery, useListProvinceQuery } from 'redux/reducers/geography';
import { nascsubdomain } from 'redux/reducers/settings';
import { useBulkCreateTrainee } from 'service/admin.query';
import { ActionType } from 'utils/action.type.enum';
import { ModuleCode } from 'utils/module.code.enum';
import { handleFileUpload } from 'utils/upload-excel';
import * as XLSX from 'xlsx';
import CsvUploadForm from './CsvUploadForm';
import TraineeDataTable from './TraineeDataTable';
import TraineeForm from './TraineeForm';
import TraineeView from './TraineeView';


const Trainee = () => {
  const timerRef = React.useRef<NodeJS.Timeout>();
  const printRef = React.useRef<null>(null);
  const [showImportModal, setshowImportModal] = useState<boolean>(false);

  const handleToggleImportModal = () => setshowImportModal(!showImportModal);
    const { data: provinceList = [] } = useListProvinceQuery({});
  
    const { data: districtData } = useListDistrictByProvinceQuery(
      {
        provinceId: 'null',
        page: 100
      },
      {
        skip: false
      }
    );
  const doaminName = getDoaminName()
  const header = doaminName === nascsubdomain ? [
    { title: "first_name", key: "first_name" },
    { title: "middle_name", key: "middle_name" },
    { title: "last_name", key: "last_name" },
    { title: "mobile_number", key: "mobile_number" },
    { title: "email", key: "email" },
    { title: "gender", key: "gender" },
    { title: "dob", key: "dob" },
  ] : [
    { title: "first_name", key: "first_name" },
    { title: "middle_name", key: "middle_name" },
    { title: "last_name", key: "last_name" },
    { title: "mobile_number", key: "mobile_number" },
    { title: "email", key: "email" },
    { title: "gender", key: "gender" },
    { title: "province_id", key: "province_id" },
    { title: "district_id", key: "district_id" },
    { title: "dob", key: "dob" },
    { title: "employee_sn", key: "employee_sn" },
    { title: "working_organization_name", key: "working_organization_name" },
    { title: "namc_or_nhpc", key: "namc_or_nhpc" },
  ];


  const [showQuery, setShowQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [formModal, setFormModal] = useToggle(false);
  const [unblockModal, setUnblockModal] = useToggle(false);
  const [csvFormModal, setCsvFormModal] = useToggle(false);
  const [traineeViewModal, setTraineeViewModal] = useToggle(false);

  const [traineeViewDetail, setTraineeViewDetail] = useState<
    (any & { id: string; attendance_pin: string }) | null
  >(null);

  const [editDetails, setEditDetails] = useState<
    (any & { id: string; attendance_pin: string }) | null
  >(null);

  const [unblockDetails, setUnblockDetails] = useState<
    (any & { id?: string; attendance_pin: string }) | null
  >(null);
  const [confirmationModal, setConfirmationModal] = useToggle(false);

  const {mutate:blukUpload,isLoading:isUploading}=useBulkCreateTrainee()



  const [headers, setHeaders] = useState<{ title: string; key: string }[]>([]);
  const [rows, setRows] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState(false);

  const isResolvedId = (val: any) =>
    val !== undefined && val !== null && val !== '' && !isNaN(Number(val));

  const GENDER_OPTIONS = [
    { id: 1, label: 'Male' },
    { id: 2, label: 'Female' },
    { id: 3, label: 'Other' },
  ];

  const resolveGender = (val: string): number | string => {
    const lower = val.toLowerCase();
    if (lower === 'male' || lower === 'पुरुष') return 1;
    if (lower === 'female' || lower === 'महिला') return 2;
    if (lower === 'other' || lower === 'अन्य') return 3;
    if (val === '1') return 1;
    if (val === '2') return 2;
    if (val === '3') return 3;
    return val; // unrecognised — keep original for dropdown
  };

  const resolveNamesToIds = (rawRows: Record<string, any>[]) => {
    return rawRows.map(row => {
      const processed = { ...row };

      if ('province_id' in processed) {
        const val = String(processed.province_id ?? '').trim();
        if (val && isNaN(Number(val))) {
          const match = (provinceList as IProvince[])?.find(
            p => p.name_en.toLowerCase() === val.toLowerCase() || p.name_np === val
          );
          processed.province_id = match ? match.id : val;
        }
      }

      if ('district_id' in processed) {
        const val = String(processed.district_id ?? '').trim();
        if (val && isNaN(Number(val))) {
          const match = districtData?.districts?.find(
            d => d.name_en.toLowerCase() === val.toLowerCase() || d.name_np === val
          );
          processed.district_id = match ? match.id : val;
        }
      }

      if ('gender' in processed) {
        const val = String(processed.gender ?? '').trim();
        if (val) processed.gender = resolveGender(val);
      }

      return processed;
    });
  };

  const renderCell = (row: Record<string, any>, colKey: string, rowIdx: number) => {
    if (colKey === 'province_id') {
      const val = row.province_id;
      if (isResolvedId(val)) {
        const province = (provinceList as IProvince[])?.find(p => p.id === Number(val));
        return <span className="text-success">{province?.name_en || String(val)}</span>;
      }
      return (
        <div style={{ minWidth: '190px' }}>
          {val && <small className="text-danger d-block mb-1">"{val}" not found</small>}
          <select
            className="form-select form-select-sm"
            value=""
            onChange={e =>
              setRows(prev =>
                prev.map((r, i) => i === rowIdx ? { ...r, province_id: Number(e.target.value) } : r)
              )
            }
          >
            <option value="">-- Select Province --</option>
            {(provinceList as IProvince[])?.map(p => (
              <option key={p.id} value={p.id}>{p.name_en}</option>
            ))}
          </select>
        </div>
      );
    }

    if (colKey === 'district_id') {
      const val = row.district_id;
      if (isResolvedId(val)) {
        const district = districtData?.districts?.find(d => d.id === Number(val));
        return <span className="text-success">{district?.name_en || String(val)}</span>;
      }
      const provinceId = isResolvedId(row.province_id) ? Number(row.province_id) : null;
      const filteredDistricts = provinceId
        ? districtData?.districts?.filter(d => d.province_id === provinceId)
        : districtData?.districts;
      return (
        <div style={{ minWidth: '190px' }}>
          {val && <small className="text-danger d-block mb-1">"{val}" not found</small>}
          <select
            className="form-select form-select-sm"
            value=""
            onChange={e =>
              setRows(prev =>
                prev.map((r, i) => i === rowIdx ? { ...r, district_id: Number(e.target.value) } : r)
              )
            }
          >
            <option value="">-- Select District --</option>
            {filteredDistricts?.map((d: IDistrict) => (
              <option key={d.id} value={d.id}>{d.name_en}</option>
            ))}
          </select>
        </div>
      );
    }

    if (colKey === 'gender') {
      const val = row.gender;
      if (isResolvedId(val)) {
        const label = GENDER_OPTIONS.find(g => g.id === Number(val))?.label || String(val);
        return <span className="text-success">{label}</span>;
      }
      return (
        <div style={{ minWidth: '150px' }}>
          {val && <small className="text-danger d-block mb-1">"{val}" not found</small>}
          <select
            className="form-select form-select-sm"
            value=""
            onChange={e =>
              setRows(prev =>
                prev.map((r, i) => i === rowIdx ? { ...r, gender: Number(e.target.value) } : r)
              )
            }
          >
            <option value="">-- Select Gender --</option>
            {GENDER_OPTIONS.map(g => (
              <option key={g.id} value={g.id}>{g.label}</option>
            ))}
          </select>
        </div>
      );
    }

    const val = row[colKey];
    return <>{val !== undefined && val !== null ? String(val) : ''}</>;
  };

  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const { headers, rows: rawRows } = await handleFileUpload(file);
      setHeaders(headers);
      setRows(resolveNamesToIds(rawRows));
    } catch (err) {
      console.error(err);
      alert('Failed to read Excel file');
    } finally {
      setLoading(false);
    }
  };
  const [unblockTrainee, { isLoading: isUnblocking }] = useUnblockTraineeMutation();
  const onEdit = (traineeDetail: any & { id: string; attendance_pin: string }) => {
    setFormModal(true);
    setEditDetails(traineeDetail);
  };

  const onView = (traineeDetail: any & { id: string; attendance_pin: string }) => {
    setTraineeViewModal(true);
    setTraineeViewDetail(traineeDetail);
  };

  const onUnblock = (traineeDetail: any & { id: string; attendance_pin: string }) => {
    setUnblockModal(true);
    setUnblockDetails(traineeDetail);
  };

  const onUnblockConfirm = () => {
    unblockDetails &&
      unblockTrainee({ id: unblockDetails?.userID })
        .unwrap()
        .then((data: any) => {
          toast.success('Unblocked Successfully');
          // setFeedbackInitialForm(FeedbackInitialValues);
          setUnblockModal(false);
        })
        .catch((err: any) => {
          toast.error('Error in unblocking');
        });
  };

  const tableRef = useRef(null);
  const handleExcelExport = () => {
    if (!tableRef.current) return;
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: 'Sheet1' });
    XLSX.writeFile(
      wb,
      `Trainee_format_${new Date().toISOString().split('T')[0]}.xlsx`
    );
  };
  


  return (
    <div>
      {formModal && <TraineeForm
        formModal={formModal}
        setFormModal={setFormModal}
        editDetails={editDetails}
      />}



      {showImportModal && (
        <Modal
          title={`Import Trainee`}
          isModalOpen={showImportModal}
          closeModal={() => handleToggleImportModal()}
          modalSize="modal-xl"
          renderFooter={() => {
            const hasProvinceField = header.some(h => h.key === 'province_id');
            const hasDistrictField = header.some(h => h.key === 'district_id');
            const hasGenderField = header.some(h => h.key === 'gender');
            const hasUnresolved = rows.length > 0 && rows.some(row =>
              (hasProvinceField && !isResolvedId(row.province_id)) ||
              (hasDistrictField && !isResolvedId(row.district_id)) ||
              (hasGenderField && !isResolvedId(row.gender))
            );
            return (
              <div className="w-100">
                {hasUnresolved && (
                  <div className="alert alert-warning py-2 mb-2 small d-flex align-items-center gap-2">
                    <i className="ri-error-warning-line fs-5" />
                    Some rows have unresolved province, district, or gender. Please select correct values from the dropdowns before uploading.
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <PrimaryButton
                    isLoading={isUploading}
                    type="button"
                    title="Upload"
                    disabled={hasUnresolved}
                    onClick={() => {
                      blukUpload({ trainees: rows }, {
                        onSuccess: (res) => {
                          if (res?.data.code == 200) {
                            handleToggleImportModal();
                          } else {
                            toast.error(res?.data?.message || "Failed to upload");
                          }
                        },
                        onError: () => {
                          toast.error("Failed to upload");
                        }
                      });
                    }}
                  />
                </div>
              </div>
            );
          }}
        >
       <div className="container-fluid py-4">
  {/* File Upload Section */}
  <div className="mb-4">
    <label className="form-label fw-bold mb-2">Upload Trainee</label>
    <input
      className="form-control"
      name="file"
      type="file"
      accept=".xlsx, .xls"
      multiple={false}
      onChange={(event) => {
        onFileChange(event);
      }}
    />
  </div>

  {/* Loading State */}
  {loading && (
    <div className="d-flex align-items-center my-3 text-primary">
      <div className="spinner-border spinner-border-sm me-2" role="status"></div>
      <span>Loading....</span>
    </div>
  )}

  {/* Table Section */}
  {rows.length > 0 && (
    <div className="card shadow-sm">
      <div className="table-responsive" style={{ maxHeight: '500px' }}>
        <table className="table table-hover table-bordered mb-0 align-middle">
          <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
            <tr>
              {header?.map((item, index) => (
                <th
                  key={item.key}
                  scope="col"
                  className="text-uppercase text-secondary fw-bold"
                  style={{ 
                    fontSize: '0.75rem', 
                    minWidth: '150px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {item.title || "Untitled"}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, idx) => (
              <tr key={idx}>
                {header?.map((col) => (
                  <td
                    key={col.key}
                    className="text-dark"
                    style={{
                      fontSize: '0.875rem',
                      minWidth: '150px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {renderCell(row, col.key, idx)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Footer Info */}
      <div className="card-footer bg-light text-muted small">
        {rows?.length} row{rows?.length !== 1 ? "s" : ""} loaded
      </div>
    </div>
  )}

  {/* Empty State */}
  {rows?.length === 0 && !loading && (
    <div className="text-center py-5 border rounded bg-light text-muted">
      Upload an Excel file to preview the data
    </div>
  )}
</div>

        </Modal>
      )}
      <>
        <div className="main-content overflow-hidden">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Trainee Management</h4>
                      <h6 className="card-title mt-2" style={{ fontSize: '12px' }}>
                        List of Trainee
                      </h6>
                    </div>
                    <div className="card-body">
                      <div id="customerList">
                        <div className="col-sm-auto">
                          <div className="d-flex">
                            <PrimaryButton
                              onClick={() => handleExcelExport()}
                              type="button"
                              className="btn btn-outline-primary add-btn"
                              small="me-2 mb-2"
                              iconName="ri-download-line align-bottom me-1"
                              data-bs-toggle="modal"
                              title="Download Trainee Format"
                              isOutline={true}
                            />
                            <PrimaryButton
                              onClick={() => handleToggleImportModal()}
                              type="button"
                              className="btn btn-outline-primary add-btn"
                              small="me-2 mb-2"
                              iconName="ri-download-line align-bottom me-1"
                              data-bs-toggle="modal"
                              title="Import Trainee"
                              isOutline={true}
                            />
                            <PrimaryButton
                              actionType={ActionType.CAN_ADD}
                              module_code={ModuleCode.TRAINEE_MANAGEMENT}

                              type="button"
                              iconName="ri-add-line align-bottom ms-1"
                              small="mb-2"
                              onClick={() => {
                                setEditDetails(null);
                                setFormModal(true);
                              }}
                              title="Create Trainee"
                            />
                            <PrintButton
                              small="mb-2 ms-2"
                              ref={printRef}
                              title="Print Document"
                              filename="my-report"
                            />



                            <div
                              className="justify-content-lg-end"
                              style={{ flexGrow: '1', display: 'flex' }}
                            >
                              <div className="search-box ms-2">
                                <input
                                  type="text"
                                  className="form-control search"
                                  placeholder="Search..."
                                  name="key"
                                  value={showQuery}
                                  onChange={(e) => {
                                    setShowQuery(e.target.value);
                                    clearTimeout(timerRef.current);
                                    timerRef.current = setTimeout(() => {
                                      setSearchQuery(e.target.value);
                                    }, 2000);
                                  }}
                                />
                                <i className="ri-search-line search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div ref={printRef} className="px-2">
                          <TraineeDataTable
                            onEdit={onEdit}
                            onView={onView}
                            onUnblock={onUnblock}
                            searchQuery={searchQuery}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <CsvUploadForm csvFormModal={csvFormModal} setCsvFormModal={setCsvFormModal} />

          {traineeViewDetail && (
            <Modal
              title={`${traineeViewDetail.first_name}'s Detail`}
              isModalOpen={traineeViewModal}
              closeModal={setTraineeViewModal}
              modalSize="modal-xl"
            >
              <TraineeView
                traineeId={traineeViewDetail?.id}
                attendance_pin={traineeViewDetail.attendance_pin}
              />
            </Modal>
          )}
          {unblockDetails && (
            <ConfirmationModal
              isOpen={unblockModal}
              onClose={setUnblockModal}
              onConfirm={onUnblockConfirm}
              title={`Unblock ${unblockDetails.first_name}`}
              btnText={'Unblock'}
              isLoading={isUnblocking}
            >
              <>
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <h4>Are you Sure ?</h4>
                  <p className="text-muted ">
                    you want to unblock{' '}
                    <b>
                      {' '}
                      {unblockDetails.first_name} {unblockDetails.last_name}
                    </b>{' '}
                  </p>
                </div>
              </>
            </ConfirmationModal>
          )}

          <ConfirmationModal
            isOpen={confirmationModal}
            onClose={setConfirmationModal}
            onConfirm={() => console.log()}
            title="Delete Confirmations"
          >
            <>
              <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                <h4>Are you Sure ?</h4>
                <p className="text-muted mx-4 mb-0">
                  Are you Sure You want to Remove this Record ?
                </p>
              </div>
            </>
          </ConfirmationModal>
        </div>
      </>
      <div className="hidden">
        <table
          ref={tableRef}
          className="w-full min-w-full divide-y divide-gray-200"
        >
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              {header?.map((item: any, index: number) => (
                <th
                  key={item.key}
                  scope="col"
                  className={`
                        px-4 py-3 text-left text-xs font-bold text-gray-700 uppercase tracking-wider
                        min-w-[150px] whitespace-nowrap
                        ${index === 0 ? "rounded-tl-xl" : ""}
                        ${index === headers.length - 1 ? "rounded-tr-xl" : ""}
                      `}
                >
                  {item.title || "Untitled"}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};

export default Trainee;
